import { h } from 'preact';
import * as BaseComp from 'base/bolt/boltApp.js';
import s from 'base/bolt/boltApp.sss';
import 'store/member';
import Store from 'store/store';
import Login from 'components/bolt/login/login';
import InfoScreen from 'components/bolt/infoScreen/infoScreen';
import FullScreenLoader from 'components/bolt/fullScreenLoader/fullScreenLoader';
import TicketArea from 'components/bolt/ticketArea/ticketArea';
import { loadSDK, setClientID } from 'helpers/credentials';
import { loadScript } from 'utils/utils';
import {
	REJECTED,
	CROSS,
	CLOSE
} from 'helpers/constants';
// import s from 'base/bolt/boltApp.sss';

import { accessNested, joinClasses } from 'utils/utils';
import { getPercentageThreshold } from 'utils/visibilityChecks';
import { navigateInternally } from 'utils/bolt';
import { getIsSinglePageIframed } from 'utils/bolt/client';

import Header from 'components/bolt/header/header';
import Footer from 'components/bolt/footer/footer';
// import SignUpForm from 'components/bolt/signUpForm/signUpForm';
import LandscapeOverlay from 'components/bolt/landscapeOverlay/landscapeOverlay';
// import TrailerOverlay from 'components/bolt/trailerOverlay/trailerOverlay';
import DynamicPageLoader from 'components/shared/dynamicPageLoader/dynamicPageLoader';
import {
	pages,
	SidePanelLoader,
	VideoOverlayLoader
} from 'pages/bolt_pages';

if (typeof window !== 'undefined') {
	window.navigateInternally = navigateInternally;
}

export default class BoltApp extends BaseComp.default {
	componentDidMount() {
		loadSDK();
		loadScript('https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js');
		window.onAmazonLoginReady = setClientID;
		super.componentDidMount();
	}

	componentDidUpdate(prevProps, prevState) {
		const copy = this.state?.appState?.appData?.copy?.baseCopy || {};
		const prevCustomer = prevState?.appState?.showtimes?.customer;
		const customer = this.state?.appState?.showtimes?.customer;
		if (customer?.id && (prevCustomer?.id !== customer?.id)) {
			Store.emit('SHOW_LOGIN_SCREEN', { show: false });
			if (this.state?.appState?.showtimes?.desiredScreen === 'ticketArea') {
				if (customer.tickets?.length < 1) {
					Store.emit('SHOW_INFO_SCREEN', {
						type: REJECTED,
						ticketIcon: CROSS,
						message: copy.$NO_TICKETS_BOOKED,
						buttons: [{ text: copy.$BOOK_TICKETS, action: CLOSE }]
					});
				} else {
					Store.emit('SHOW_TICKET_AREA', true);
				}
				Store.emit('RESET_DESIRED_SCREEN');
			}
		}
		super.componentDidUpdate(prevProps, prevState);
	}

	renderMoreThings() {
		const showtimesStore = this.state?.appState?.showtimes || {};
		const appData = this.state?.appState?.appData || {};
		const client = this.state?.appState?.client || {};
		return (
			<div>
				<Login showtimesStore={showtimesStore} appData={appData} client={client} />
				<InfoScreen show={showtimesStore.showInfoScreen} appData={appData} data={showtimesStore.infoScreenData} ticketData={showtimesStore?.customer?.tickets} storedEarlyAccessCode={showtimesStore?.earlyAccessCode} />
				<TicketArea show={showtimesStore.showTicketArea} appData={appData} ticketData={showtimesStore?.customer?.tickets} client={client} />
				<FullScreenLoader show={showtimesStore.showFullScreenLoader} />
			</div>
		);
	}

	renderMain(props, state) {
		const { appState, backgroundStyle, fallbackBackgroundStyle, audioMuted, bgVideo } = state;

		const {
			activePage,
			appData,
			client,
			videos,
			header,
			showtimes,
			homeEnt,
			scrollerTallerThanWindow,
			widgetFullyExpanded
		} = appState;

		let mainPage = activePage;
		let activePageDetails = appData?.pages?.[activePage];
		if (activePageDetails?.section) {
			// TODO: ability to attach sections to different pages
			mainPage = Object.values(pages).find(page => page.page === 'home')?.id || 'boltHome';
		}
		// For overlays (e.g. boltShowtimes), activePage changes but it is not in pages
		//   when that's the case, keep using the previous one
		let page = pages[mainPage] || this.currentPage;
		if (activePageDetails?.customPageComponent && pages[activePageDetails.customPageComponent]) {
			page = { ...pages[activePageDetails.customPageComponent], id: activePageDetails.id };
		}
		if (props.renderedPage) {
			page = props.renderedPage;
		}
		this.currentPage = page;

		const orientation = state.orientation;
		const isMobile = (client && !client.isDesktopSize);
		const isMobileLandscape = (client?.deviceSize === 'mobile') && (orientation === 'landscape');
		const isTabletLandscape = (client?.device !== 'desktop') && !isMobileLandscape && (orientation === 'landscape');
		const videoOverlayOpen = videos && videos.overlayOpen;
		const showtimesOverlayOpen = showtimes && showtimes.show;
		const showtimesAnimation = showtimes && showtimes.animate;
		const homeEntOverlayOpen = homeEnt && homeEnt.show;
		const homeEntAnimation = homeEnt && homeEnt.animate;
		const sidePanelOpen = showtimesOverlayOpen || homeEntOverlayOpen;
		const sidePanelAnimation = showtimesAnimation || homeEntAnimation;
		// const headerOpen = accessNested(this.state, 'appState.header.open', false);
		const homeActivePercentage = accessNested(appState, 'homeActivePercentage', 1);
		const hubActivePercentage = accessNested(appState, 'hubActivePercentage', 1);
		// Hides the background to prevent it being visible on iOS overscroll
		const hideBackground = !homeActivePercentage && isMobile;
		const hasStickyFooter = accessNested(appData, 'footer.sticky', false);
		const externalBannerOpen = accessNested(this.state, 'appState.externalCookieBanner.bannerOpen', false);
		const cookieMode = externalBannerOpen || (accessNested(this.state, 'appState.cookies.pushDown', false) && accessNested(this.state, 'appState.cookies.cookieBannerOpen', false));
		const oneContinuousScroll = (externalBannerOpen && isMobile) || accessNested(appData, 'options.oneContinuousScroll'); // Makes the whole main page one big scrolling section to cater for the giant Evidon banner (or for other reasons).
		const sonyHeaderEnabled = accessNested(appData, 'options.sonyFeatures.sonyHeader', false) && !getIsSinglePageIframed();

		const sonyFooterEnabled = accessNested(appData, 'footer.sonyFooter', false);
		const accessibilityCopy = accessNested(appData, 'copy.accessibilityCopy', {});
		const disableMobileLandscape = accessNested(appData, 'options.disableLandscape');
		const disableTabletLandscape = accessNested(appData, 'options.disableTabletLandscape');
		const videoOverlay = accessNested(appData, 'options.videoOverlay', null);
		const landingAudio = accessNested(appData, 'options.landingAudio', null);
		const visibleScrollbar = accessNested(appData, 'options.paramountFeatures.visibleScrollbar', false);
		const iframeLandscapeEnabled = accessNested(appData, 'pages.boltIframe.data.disableOrientationLock', false) && activePage === 'boltIframe';
		const showLandscapeOverlay = ((isMobileLandscape && disableMobileLandscape) || (isTabletLandscape && disableTabletLandscape)) && !iframeLandscapeEnabled;
		const hasMiniGallery = accessNested(appData, 'options.paramountFeatures.toutCarousel.contentCarousel', false);
		const videoHasAudio = accessNested(appData, 'pages.boltHome.data.bg.videoHasAudio', false);
		const iconPosition = accessNested(appData, 'pages.boltHome.data.bg.iconPosition', 'top-left');

		const mainScrollStyle = {};
		if (visibleScrollbar) {
			mainScrollStyle.scrollbarColor = `${visibleScrollbar.color} ${visibleScrollbar.backgroundColor}`;
		}

		let headerOffset = 0;

		const bgCookieStyle = {};

		if (sonyHeaderEnabled) {
			headerOffset = 34;
		}

		if (cookieMode && typeof window !== 'undefined') {
			bgCookieStyle.position = oneContinuousScroll ? 'absolute' : 'fixed';
			const cookieHeight = (externalBannerOpen ? accessNested(appState, 'externalCookieBanner.height') : accessNested(appState, 'cookies.height')) || 0;
			headerOffset += cookieHeight;
			bgCookieStyle.top = `${oneContinuousScroll ? '0' : headerOffset}px`;
			bgCookieStyle.height = (oneContinuousScroll ? window.innerHeight : window.innerHeight - headerOffset) + 'px';
		}

		// TODO: detect if ANY overlay is open in a generic way
		const headerHeight = accessNested(Store.get(), 'client.headerHeight', 0);
		const desktopSolidHeader = accessNested(appData, 'header.powsterHeader.desktopSolidHeader', null);
		const hub = accessNested(appData, 'pages.boltHubPage') && !accessNested(appData, 'pages.boltHome');
		const previewPanelReplacingHomePage = appData?.pages.boltPreviewPanel && !appData?.pages.boltHome;
		const dedicatedPage = pages[activePage] && activePage !== 'boltHome' && !activePageDetails?.section;
		const homeInactive = (homeActivePercentage <= getPercentageThreshold(headerOffset)) || activePage !== 'boltHome';
		const hubInactive = (hubActivePercentage <= getPercentageThreshold(headerHeight));
		let headerSolidBackground = hub ? hubInactive && !sidePanelOpen && !videoOverlayOpen : homeInactive && !sidePanelOpen && !videoOverlayOpen;
		if (previewPanelReplacingHomePage || !scrollerTallerThanWindow || widgetFullyExpanded || Store.get().activePage === 'boltPhotobooth') {
			headerSolidBackground = false;
		}
		// Potentially wait for other initial things to load
		const loaded = this.checkIfLoaded();

		let hasShowtimes = Object.values(appData.pages).some(p => p?.type === 'showtimes');
		let hasHomeEnt = Object.values(appData.pages).some(p => p?.type === 'homeEnt');
		let hasPressKit = Object.values(appData.pages).some(p => p?.type === 'pressKit');

		let bgRender = this.state.bgVideo ? this.renderBgVideo(homeActivePercentage, bgCookieStyle, fallbackBackgroundStyle) : (
			<div
				class={joinClasses({
					s, background: true,
					sidePanelOpen,
					hasStickyFooter,
					cookieMode,
					hideBackground,
					sidePanelAnimation,
					hasMiniGallery
				})}
				style={{ ...backgroundStyle, ...bgCookieStyle }}
				key="background"
				role="img"
				ariaLabel={accessibilityCopy.$BACKGROUND_IMAGE_ARIA}
			/>
		);

		let pageProps = {};
		if (page) {
			pageProps = {
				store: appState,
				client: appState.client,
				appData,
				id: page.id,
				data: appData.pages[page.id]?.data,
				bgRender: oneContinuousScroll && bgRender
			};
			if (page.page) {
				pageProps[page.page] = appState[page.page];
			}
		}

		return (
			<div
				class={joinClasses(
					s.mainScroll,
					loaded && 'contentLoaded',
					(!visibleScrollbar || isMobile) && s.hideScrollbar,
					dedicatedPage && s.dedicatedPage
				)}
				id="mainScroll"
				style={mainScrollStyle}
			>
				<Header
					closeAllOverlays={this.closeAllOverlays}
					client={client}
					appData={appData}
					activePage={activePage}
					solidBackground={headerSolidBackground}
					headerData={header}
					offsetTop={headerOffset}
					isCalendarRemindMode={this.isCalendarRemindMode}
					calRemindOpen={appState.calRemindOpen}
					desktopSolidHeader={desktopSolidHeader}
					footerData={appState.footer}
					key="header"
				/>
				<h1 class={s.pageName}>{this.getH1(appData, page, activePageDetails, activePage)}</h1>
				{bgRender}
				{this.CalRemind && <this.CalRemind appData={appData} open={appState.calRemindOpen} offsetTop={headerOffset} key="calendarRemind" />}
				<DynamicPageLoader
					class={s.pageContainer}
					containerClass={joinClasses(s.pageWrapper, 'pageWrapper')}
					page={page}
					props={pageProps}
					onLoad={this.onPageContentLoad}
					key="dynamicPageLoader"
				/>
				{(!sidePanelOpen || sonyFooterEnabled) && <Footer data={appData.footer} store={appState} key="footer" />}
				{VideoOverlayLoader && <VideoOverlayLoader store={appState} key="videoLoader" />}
				{hasShowtimes && <SidePanelLoader store={appState} key="showtimesLoader" />}
				{hasHomeEnt && <SidePanelLoader store={appState} key="homeEntLoader" />}
				{hasPressKit && <SidePanelLoader store={appState} key="pressKitLoader" />}
				{this.TrailerOverlay && <this.TrailerOverlay data={videoOverlay} store={appState} />}
				{this.PressKitGalleryOverlay && <this.PressKitGalleryOverlay store={appState} />}
				{this.LandingAudio && <this.LandingAudio data={landingAudio} offsetTop={headerOffset} store={appState} />}
				{(videoHasAudio && bgVideo) && (
					<div onClick={this.toggleAudio} class={joinClasses(s.sound, audioMuted && s.muted, s[iconPosition])}>
						<button class={s.icon} />
					</div>
				)}
				{(!videoOverlayOpen && showLandscapeOverlay) && <LandscapeOverlay key="landscape-overlay" />}
				{this.renderLoadingOccluder()}
				{this.getExtra()}
			</div>
		);
	}

	render(props, state) {
		const base = super.render(props, state);
		const amazonRoot = <div id="amazon-root" />;
		const moreThings = this.renderMoreThings();
		base.children.unshift(amazonRoot);
		base.children.push(moreThings);
		return base;
	}

}
